import React, { useState, useEffect } from "react";
import Api from "../../../services/api";
import {
    Button,
    Form,
    Row,
    Col,
    InputGroup,
    FormControl,
} from "react-bootstrap";
import {
    Collapse,
    Modal,
    Select,
    Space,
    Input,
    DatePicker,
    Button as AntButton,
    Radio,
    Tabs,
    Divider,
    InputNumber,
    Descriptions,
    Badge,
    Checkbox,
    Alert
} from "antd";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Label,
    Bar
} from "recharts";
import moment from "moment";

import TableContainer from "../../../components/TableContainer";

function AppPrediction() {

    const [metricsExpanded, setMetricsExpanded] = useState(false);


    const [hasRunReportTop, setHasRunReportTop] = useState(false);
    const [hasRunReportMetrics, setHasRunReportMetrics] = useState(false);


    const [sortConfig, setSortConfig] = useState({ field: null, direction: null });
    const [showPopup, setShowPopup] = useState(false);
    const [showFilterPanel, setShowFilterPanel] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [filters, setFilters] = useState({ searchTerm: "", conditions: {}, expandedFields: {} });
    const [columnFilterPopup, setColumnFilterPopup] = useState({ activeColumn: null, position: { top: 0, left: 0 } });
    const columnPopupRef = React.useRef(null);

    const [fields, setFields] = useState([
        { key: "country", label: "Country", checked: true },
    ]);

    const [filterableColumns] = useState([
        "cost_1",
        "install_ad_network_2",
        "install_ad_network",
        "attributed_ecpi",
        "roas_d0",
        "ltv_d0",
    ]);

    const [columnOrder, setColumnOrder] = useState([
        "cost_1",
        "install_ad_network_2",
        "install_ad_network",
        "attributed_ecpi",
        "roas_d0",
        "ltv_d0",
    ]);

    const { TabPane } = Tabs;
    const { RangePicker } = DatePicker;

    const getFieldLabel = (field) => {
        const fieldMap = {
            cost_1: "Cost 1",
            install_ad_network_2: "Attributed Installs 2",
            install_ad_network: "Attributed Installs",
            roas_d0:"ROAS D0",
            ltv_d0:"LTV D0",
        };
        return fieldMap[field] || field;
    };

    const moveColumn = (from, to) => {

        let fromIndex = typeof from === "string" ? columnOrder.indexOf(from) : from;
        let toIndex = typeof to === "string" ? columnOrder.indexOf(to) : to;
        if (fromIndex < 0 || toIndex < 0) return;
        const newOrder = [...columnOrder];
        const [movedItem] = newOrder.splice(fromIndex, 1);
        newOrder.splice(toIndex, 0, movedItem);
        setColumnOrder(newOrder);
    };

    const [visibleColumns, setVisibleColumns] = useState({});

    const dataTotal = {};
    const METRIC_FORMATS = {};
    const sortedData = [];
    const toggleSort = () => {};
    const hasActiveFilter = () => false;
    const handleColumnFilterClick = (field, event) => {
        const rect = event.currentTarget.getBoundingClientRect();
        setColumnFilterPopup({ activeColumn: field, position: { top: rect.bottom, left: rect.left } });
    };
    const renderGroup = () => null;
    const formatNumber = (num) => num.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const updateCondition = () => {};
    const toggleFieldExpand = () => {};
    const setAllColumnsVisible = () => {};
    const renderFilterFieldControls = () => null;


    const runReport = (data) => {
        console.log("Run Report:", data);
        setHasRunReportTop(true);
    };



    const getVisibleColumns = () => columnOrder.filter((f) => visibleColumns[f] !== false);

    const [mode, setMode] = useState("Simplified");
    const [chartType, setChartType] = useState("LTV");

    const dataSimplified = [
        { day: "D0", Max_Percentage: 45.37, Average_Precentage: 40.17, Min_Percentage: 33.37 },
        { day: "D1", Max_Percentage: 61.15, Average_Precentage: 54.9, Min_Percentage: 48.59 },
        { day: "D2", Max_Percentage: 70.82, Average_Precentage: 65.12, Min_Percentage: 59.16 },
        { day: "D4", Max_Percentage: 79.97, Average_Precentage: 74.6, Min_Percentage: 69.02 },
        { day: "D7", Max_Percentage: 88.82, Average_Precentage: 83.36, Min_Percentage: 77.36 },
        { day: "D14", Max_Percentage: 95.69, Average_Precentage: 92.06, Min_Percentage: 88.9 },
        { day: "D30", Max_Percentage: 99, Average_Precentage: 98, Min_Percentage: 97 }
    ];

    const dataDetail = [
        { day: "Day 1", D1: 10, D2: 15, D3: 20 },
        { day: "Day 2", D1: 20, D2: 25, D3: 30 },
        { day: "Day 3", D1: 35, D2: 40, D3: 42 },
        { day: "Day 4", D1: 45, D2: 50, D3: 55 },
        { day: "Day 5", D1: 55, D2: 65, D3: 70 },
    ];

    const dataPanel12 = [
        {
            day: "D0",
            Predicted_Max_LTV: 40,
            Predicted_Average_LTV: 35,
            Predicted_Min_LTV: 30,
            Actual_LTV: 38,
            Predicted_Max_ROAS: 15,
            Predicted_Average_ROAS: 12,
            Predicted_Min_ROAS: 10,
            Actual_ROAS: 13,
        },
        {
            day: "D1",
            Predicted_Max_LTV: 55,
            Predicted_Average_LTV: 50,
            Predicted_Min_LTV: 45,
            Actual_LTV: 53,
            Predicted_Max_ROAS: 20,
            Predicted_Average_ROAS: 18,
            Predicted_Min_ROAS: 15,
            Actual_ROAS: 17,
        },
        {
            day: "D3",
            Predicted_Max_LTV: 80,
            Predicted_Average_LTV: 70,
            Predicted_Min_LTV: 65,
            Actual_LTV: 75,
            Predicted_Max_ROAS: 40,
            Predicted_Average_ROAS: 35,
            Predicted_Min_ROAS: 30,
            Actual_ROAS: 32,
        },
    ];

    const dataPanel31 = [
        { day: "D0", Actual_Ad_LTV: 45.37, Actual_IAP_LTV: 40.17, Predicted_LTV: 33.37 , Actual_LTV: 22.3},
        { day: "D1", Actual_Ad_LTV: 61.15, Actual_IAP_LTV: 54.9, Predicted_LTV: 48.59 , Actual_LTV: 22.3},
        { day: "D2", Actual_Ad_LTV: 70.82, Actual_IAP_LTV: 65.12, Predicted_LTV: 59.16 , Actual_LTV: 22.3},
        { day: "D4", Actual_Ad_LTV: 79.97, Actual_IAP_LTV: 74.6, Predicted_LTV: 69.02 , Actual_LTV: 22.3},
        { day: "D7", Actual_Ad_LTV: 88.82, Actual_IAP_LTV: 83.36, Predicted_LTV: 77.36 , Actual_LTV: 22.3},
        { day: "D14", Actual_Ad_LTV: 95.69, Actual_IAP_LTV: 92.06, Predicted_LTV: 88.9 , Actual_LTV: 22.3},
        { day: "D30", Actual_Ad_LTV: 99, Actual_IAP_LTV: 98, Predicted_LTV: 97 , Actual_LTV: 22.3}
    ];

    const dataPanel21 = [
        { day: "D0", Actual_Retention_Rate: 45.37, Predicted_Retention_Rate: 40.17},
        { day: "D1", Actual_Retention_Rate: 61.15, Predicted_Retention_Rate: 54.9},
        { day: "D2", Actual_Retention_Rate: 70.82, Predicted_Retention_Rate: 65.12},
        { day: "D4", Actual_Retention_Rate: 79.97, Predicted_Retention_Rate: 74.6},
        { day: "D7", Actual_Retention_Rate: 88.82, Predicted_Retention_Rate: 83.36},
        { day: "D14", Actual_Retention_Rate: 95.69, Predicted_Retention_Rate: 92.06},
        { day: "D30", Actual_Retention_Rate: 99, Predicted_Retention_Rate: 98}
    ];
    const dataPanel22 = [
        { day: "D0", Ad_RPDAU: 45.37, IAP_RPDAU: 40.17, Overall_RPDAU: 2.6},
        { day: "D1", Ad_RPDAU: 61.15, IAP_RPDAU: 54.9, Overall_RPDAU: 2.6},
        { day: "D2", Ad_RPDAU: 70.82, IAP_RPDAU: 65.12, Overall_RPDAU: 2.6},
        { day: "D4", Ad_RPDAU: 79.97, IAP_RPDAU: 74.6, Overall_RPDAU: 2.6},
        { day: "D7", Ad_RPDAU: 88.82, IAP_RPDAU: 83.36, Overall_RPDAU: 2.6},
        { day: "D14", Ad_RPDAU: 95.69, IAP_RPDAU: 92.06, Overall_RPDAU: 2.6},
        { day: "D30", Ad_RPDAU: 99, IAP_RPDAU: 98, Overall_RPDAU: 2.6}
    ];
    const dataPanel23 = [
        { day: "D0", Actual_LTV: 45.37, Predicted_LTV: 40.17},
        { day: "D1", Actual_LTV: 61.15, Predicted_LTV: 54.9},
        { day: "D2", Actual_LTV: 70.82, Predicted_LTV: 65.12},
        { day: "D4", Actual_LTV: 79.97, Predicted_LTV: 74.6},
        { day: "D7", Actual_LTV: 88.82, Predicted_LTV: 83.366},
        { day: "D14", Actual_LTV: 95.69, Predicted_LTV: 92.06},
        { day: "D30", Actual_LTV: 99, Predicted_LTV: 98}
    ];


    return (
        <>

            <div className="background-second-dashboard">
                <section className="main__content-dashbard firebase-theme">
                    <div className="container-fluid">
                        <Tabs defaultActiveKey="1" type="card">
                            <TabPane tab="Charts" key="1">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="tab-content" id="nav-tabContent">
                                            <div
                                                className="tab-pane fade show active"
                                                id="nav-home"
                                                role="tabpanel"
                                                aria-labelledby="nav-home-tab"
                                            >
                                                <div className="detail-body">
                                                    <div className="overview_content pd-20">
                                                        <Form layout="vertical">
                                                            <Row gutter={8} align="" className="mb-4">
                                                                <Col md={2}>
                                                                    <div className="filter-group">
                                                                        <Select
                                                                            placeholder="Select an ad network"
                                                                            options={[
                                                                                { value: " FB ads (FT Global - Inv1)", label: " FB ads (FT Global - Inv1)" },
                                                                                { value: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)", label: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)" },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={2} >
                                                                    <div className="filter-group">
                                                                        <Select
                                                                            placeholder="Select campaign"
                                                                            options={[
                                                                                { value: " FB ads (FT Global - Inv1)", label: " FB ads (FT Global - Inv1)" },
                                                                                { value: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)", label: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)" },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={2} >
                                                                    <div className="filter-group">
                                                                        <Select
                                                                            placeholder="Select country"
                                                                            options={[
                                                                                { value: " FB ads (FT Global - Inv1)", label: " FB ads (FT Global - Inv1)" },
                                                                                { value: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)", label: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)" },
                                                                            ]}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={2} >
                                                                    <div className="filter-group">
                                                                        <RangePicker
                                                                            ranges={{
                                                                                'This Week': [moment().startOf('week'), moment().endOf('week')],
                                                                                'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                                                                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                                                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                                                                'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                                                                                'Last 10 Days': [moment().subtract(10, 'days'), moment()],
                                                                                'Last 30 Days': [moment().subtract(30, 'days'), moment()],
                                                                            }}
                                                                            style={{ width: '100%' }}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                                <Col md={2} >
                                                                    <div className="filter-group" style={{ display: "flex", alignItems: "center", gap: 8, flexDirection: "unset" }}>
                                                                        <div>Predict LTV</div>
                                                                        <InputNumber
                                                                            style={{ width: 100 }}
                                                                            formatter={(value) => `D ${value || ''}`}
                                                                            parser={(value) => value.replace(/^D\s?/, '')}
                                                                            placeholder="Nhập số"
                                                                        />
                                                                    </div>
                                                                </Col>

                                                                <Col md={2} >
                                                                    <AntButton
                                                                        type="primary"
                                                                        onClick={() => setHasRunReportMetrics(true)}
                                                                        className="run-report-btn"
                                                                    >
                                                                        Run
                                                                    </AntButton>
                                                                </Col>
                                                            </Row>
                                                        </Form>

                                                        <div className="mb-6">
                                                            <Descriptions title="Information" bordered>
                                                                <Descriptions.Item label="Ad Network / Attributed eCPI">$1.968 / $1.74</Descriptions.Item>
                                                                <Descriptions.Item label="Ad Network / Attributed Installs">17,160 / 19,409</Descriptions.Item>
                                                            </Descriptions>
                                                        </div>

                                                        <div className="mb-6">
                                                            <Collapse onChange={(keys) => setMetricsExpanded(keys?.includes("1"))}>
                                                                <Collapse.Panel
                                                                    header={<span className="metrics-header">Predict LTV using Monetisation Curve with historical data</span>}
                                                                    key="1"
                                                                >
                                                                    <Row className="mb-4">
                                                                        <Col md={12} className="d-flex justify-content-between">
                                                                            <h5>
                                                                                <b>Monetisation Curve (Percentage of LTV Dx in relation to LTV D)</b>
                                                                            </h5>
                                                                            <Radio.Group value={mode} onChange={(e) => setMode(e.target.value)}>
                                                                                <Radio.Button value="Simplified">Simplified</Radio.Button>
                                                                                <Radio.Button value="Detail">Detail</Radio.Button>
                                                                            </Radio.Group>
                                                                        </Col>
                                                                    </Row>

                                                                    <Form layout="vertical" className="mb-4">
                                                                        <Row >
                                                                            <Col md={2}>
                                                                                <div className="filter-group">
                                                                                    <Select
                                                                                        placeholder="Select app"
                                                                                        options={[
                                                                                            { value: " FB ads (FT Global - Inv1)", label: " FB ads (FT Global - Inv1)" },
                                                                                            { value: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)", label: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)" },
                                                                                        ]}
                                                                                    />
                                                                                </div>
                                                                            </Col>
                                                                            <Col md={2} >
                                                                                <div className="filter-group">
                                                                                    <RangePicker
                                                                                        ranges={{
                                                                                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                                                                                            'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                                                                                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                                                            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                                                                            'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                                                                                            'Last 10 Days': [moment().subtract(10, 'days'), moment()],
                                                                                            'Last 30 Days': [moment().subtract(30, 'days'), moment()],
                                                                                        }}
                                                                                        style={{ width: '100%' }}
                                                                                    />
                                                                                </div>
                                                                            </Col>
                                                                            <Col md={2} >
                                                                                <div className="filter-group">
                                                                                    <Select
                                                                                        placeholder="Select country"
                                                                                        options={[
                                                                                            { value: " FB ads (FT Global - Inv1)", label: " FB ads (FT Global - Inv1)" },
                                                                                            { value: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)", label: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)" },
                                                                                        ]}
                                                                                    />
                                                                                </div>
                                                                            </Col>
                                                                            <Col md={4} >
                                                                                <div className="filter-group" style={{ display: "flex", alignItems: "center", gap: 8, flexDirection: "unset" }}>
                                                                                    <div>Min attributed installs per day:</div>
                                                                                    <InputNumber
                                                                                        style={{ width: 100 }}
                                                                                        placeholder=""
                                                                                    />
                                                                                    <Checkbox style={{ marginBottom: "0px" }} label>Split by Campaign</Checkbox>
                                                                                </div>
                                                                            </Col>
                                                                            <Col md={1} >
                                                                                <AntButton
                                                                                    type="primary"
                                                                                >
                                                                                    Apply
                                                                                </AntButton>
                                                                            </Col>

                                                                        </Row>
                                                                    </Form>

                                                                    <div className="flex items-start justify-between w-full">
                                                                        <div className="ml-4 text-right font-semibold">
                                                                            <b>Attributed eCPI:$0.857</b>
                                                                        </div>
                                                                        <div className="flex-1 h-[400px]">
                                                                            <ResponsiveContainer width="100%" height={400}>
                                                                                <LineChart data={mode === "Simplified" ? dataSimplified : dataDetail}>
                                                                                    <CartesianGrid strokeDasharray="3 3" />
                                                                                    <XAxis dataKey="day" />
                                                                                    <YAxis domain={[0, 100]} />
                                                                                    <Tooltip />
                                                                                    <Legend />
                                                                                    {mode === "Simplified" ? (
                                                                                        <>
                                                                                            <Line type="monotone" dataKey="Max_Percentage" stroke="#1f77b4" dot={{ r: 3 }} />
                                                                                            <Line type="monotone" dataKey="Average_Precentage" stroke="#ff7f0e" dot={{ r: 3 }} />
                                                                                            <Line type="monotone" dataKey="Min_Percentage" stroke="#ffbb00" dot={{ r: 3 }} />
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <Line type="monotone" dataKey="D1" stroke="#1f77b4" dot={{ r: 3 }} />
                                                                                            <Line type="monotone" dataKey="D2" stroke="#ff7f0e" dot={{ r: 3 }} />
                                                                                            <Line type="monotone" dataKey="D3" stroke="#ffbb00" dot={{ r: 3 }} />
                                                                                        </>
                                                                                    )}
                                                                                </LineChart>
                                                                            </ResponsiveContainer>
                                                                        </div>

                                                                    </div>

                                                                    <div className="flex items-start justify-between w-full">
                                                                        <div className="d-flex justify-content-between font-semibold mb-4">
                                                                            <Select
                                                                                defaultValue="ltv"
                                                                                style={{ width: 120 }}
                                                                                options={[
                                                                                    { value: "LTV", label: "LTV" },
                                                                                    { value: "ROAS", label: "ROAS" },
                                                                                ]}
                                                                                onChange={(value) => setChartType(value)}
                                                                            />
                                                                            <b>Attributed eCPI:$1.74</b>
                                                                        </div>

                                                                        <div className="flex-1 h-[400px]">
                                                                            <ResponsiveContainer width="100%" height={400}>
                                                                                <LineChart data={dataPanel12}>
                                                                                    <CartesianGrid strokeDasharray="3 3" />
                                                                                    <XAxis dataKey="day" />
                                                                                    <YAxis domain={[0, 100]} />
                                                                                    <Tooltip />
                                                                                    <Legend />
                                                                                    <Line
                                                                                        type="monotone"
                                                                                        dataKey={`Predicted_Max_${chartType}`}
                                                                                        stroke="#1f77b4"
                                                                                        dot={{ r: 3 }}
                                                                                    />
                                                                                    <Line
                                                                                        type="monotone"
                                                                                        dataKey={`Predicted_Average_${chartType}`}
                                                                                        stroke="#ff7f0e"
                                                                                        dot={{ r: 3 }}
                                                                                    />
                                                                                    <Line
                                                                                        type="monotone"
                                                                                        dataKey={`Predicted_Min_${chartType}`}
                                                                                        stroke="#ffbb00"
                                                                                        dot={{ r: 3 }}
                                                                                    />
                                                                                    <Line
                                                                                        type="monotone"
                                                                                        dataKey={`Actual_${chartType}`}
                                                                                        stroke="#2ca02c"
                                                                                        dot={{ r: 3 }}
                                                                                    />
                                                                                </LineChart>
                                                                            </ResponsiveContainer>
                                                                        </div>
                                                                    </div>
                                                                </Collapse.Panel>

                                                                <Collapse.Panel
                                                                    header={<span className="metrics-header">Predict LTV Dx using formula LTV Dx = LTV D(x-1) + (Retention Rate Dx * ARPDAU Dx)</span>}
                                                                    key="2"
                                                                >

                                                                    <Row className="mb-4">
                                                                        <Col md={6}>
                                                                            <div className="flex items-start justify-between w-full">
                                                                                <div className="ml-4 text-left font-semibold">
                                                                                    <b>Retention Rate</b>
                                                                                </div>
                                                                                <div className="flex-1 h-[400px]">
                                                                                    <ResponsiveContainer width="100%" height={400}>
                                                                                        <LineChart data={dataPanel21}>
                                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                                            <XAxis dataKey="day" />
                                                                                            <YAxis domain={[0, 100]} />
                                                                                            <Tooltip />
                                                                                            <Legend />
                                                                                            <Line
                                                                                                type="monotone"
                                                                                                dataKey="Actual_Retention_Rate"
                                                                                                stroke="#1f77b4"
                                                                                                dot={{ r: 3 }}
                                                                                            />
                                                                                            <Line
                                                                                                type="monotone"
                                                                                                dataKey="Predicted_Retention_Rate"
                                                                                                stroke="#d62728"
                                                                                                strokeDasharray="5 5"
                                                                                                dot={false}
                                                                                            />
                                                                                        </LineChart>
                                                                                    </ResponsiveContainer>
                                                                                </div>

                                                                            </div>
                                                                        </Col>

                                                                        <Col md={6}>
                                                                            <div className="flex items-start justify-between w-full">
                                                                                <div className="d-flex justify-content-between font-semibold mb-4">
                                                                                    <b>ARPDAU</b>
                                                                                    <b>Average: $0.247</b>
                                                                                </div>
                                                                                <div className="flex-1 h-[400px]">
                                                                                    <ResponsiveContainer width="100%" height={400}>
                                                                                        <LineChart data={dataPanel22}>
                                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                                            <XAxis dataKey="day" />
                                                                                            <YAxis domain={[0, 100]} />
                                                                                            <Tooltip />
                                                                                            <Legend />
                                                                                            <Bar dataKey="Ad_RPDAU" barSize={20} fill="#8884d8" name="Ad RPDAU" />
                                                                                            <Bar dataKey="IAP_RPDAU" barSize={20} fill="#8884d8" name="IAP RPDAU" />
                                                                                            <Line
                                                                                                type="monotone"
                                                                                                dataKey="Overall_RPDAU"
                                                                                                stroke="#d62728"
                                                                                                strokeDasharray="5 5"
                                                                                                dot={false}
                                                                                            />
                                                                                        </LineChart>
                                                                                    </ResponsiveContainer>
                                                                                </div>

                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className="mb-4">
                                                                        <Col md={12}>
                                                                            <div className="flex items-start justify-between w-full">
                                                                                <div className="d-flex justify-content-between font-semibold mb-4">
                                                                                    <Select
                                                                                        defaultValue="ltv"
                                                                                        options={[
                                                                                            { value: "ltv", label: "LTV" },
                                                                                            { value: "roas", label: "ROAS" },
                                                                                        ]}
                                                                                    />

                                                                                    <div>
                                                                                        Future ARPDAU:
                                                                                        <Radio.Group value="Use_latest_ARPDAU">
                                                                                            <Radio.Button value="Use_latest_ARPDAU">Use latest ARPDAU</Radio.Button>
                                                                                            <Radio.Button value="Use_average_ARPDAU">Use average ARPDAU</Radio.Button>
                                                                                        </Radio.Group>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="flex-1 h-[400px]">
                                                                                    <ResponsiveContainer width="100%" height={400}>
                                                                                        <LineChart data={dataPanel23}>
                                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                                            <XAxis dataKey="day" />
                                                                                            <YAxis domain={[0, 100]} />
                                                                                            <Tooltip />
                                                                                            <Legend />
                                                                                            <Line
                                                                                                type="monotone"
                                                                                                dataKey="Actual_LTV"
                                                                                                stroke="#ffbb00"
                                                                                                dot={{ r: 3 }}
                                                                                            />
                                                                                            <Line
                                                                                                type="monotone"
                                                                                                dataKey="Predicted_LTV"
                                                                                                stroke="#ffbb00"
                                                                                                dot={{ r: 3 }}
                                                                                            />
                                                                                        </LineChart>
                                                                                    </ResponsiveContainer>
                                                                                </div>

                                                                            </div>
                                                                        </Col>
                                                                    </Row>

                                                                </Collapse.Panel>

                                                                <Collapse.Panel
                                                                    header={<span className="metrics-header">Predict LTV Dx using Power function on current data</span>}
                                                                    key="3"
                                                                >
                                                                    <Row className="mb-4">
                                                                        <Col md={12}>
                                                                            <div className="flex items-start justify-between w-full">
                                                                                <div className="d-flex justify-content-between font-semibold mb-4">
                                                                                    <Select
                                                                                        defaultValue="ltv"
                                                                                        options={[
                                                                                            { value: "ltv", label: "LTV" },
                                                                                            { value: "roas", label: "ROAS" },
                                                                                        ]}
                                                                                    />

                                                                                    <b>Predicted D0:$0</b>
                                                                                </div>
                                                                                <div className="flex-1 h-[400px]">
                                                                                    <ResponsiveContainer width="100%" height={400}>
                                                                                        <LineChart data={dataPanel31}>
                                                                                            <CartesianGrid strokeDasharray="3 3" />
                                                                                            <XAxis dataKey="day" />
                                                                                            <YAxis domain={[0, 100]} />
                                                                                            <Tooltip />
                                                                                            <Legend />
                                                                                            <Bar dataKey="Actual_Ad_LTV" barSize={20} fill="#8884d8" name="Actual Ad LTV" />
                                                                                            <Bar dataKey="Actual_IAP_LTV" barSize={20} fill="#8884d8" name="Actual IAP LTV" />
                                                                                            <Line
                                                                                                type="monotone"
                                                                                                dataKey="Actual_LTV"
                                                                                                stroke="#ffbb00"
                                                                                                dot={{ r: 3 }}
                                                                                            />
                                                                                            <Line
                                                                                                type="monotone"
                                                                                                dataKey="Predicted_LTV"
                                                                                                stroke="#ffbb00"
                                                                                                dot={{ r: 3 }}
                                                                                            />
                                                                                        </LineChart>
                                                                                    </ResponsiveContainer>
                                                                                </div>

                                                                            </div>
                                                                        </Col>
                                                                    </Row>

                                                                </Collapse.Panel>
                                                            </Collapse>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </TabPane>
                            <TabPane tab="Table" key="2">
                                <div className="card">
                                    <div className="card-body">
                                        <Row className="mb-4">
                                            <Col md={12}>
                                                <Alert message="The predicted metrics in this table is using formula LTV Dx = LTV D(x-1) + (Retention Rate Dx * ARPDAU Dx)" type="info" />
                                            </Col>
                                        </Row>
                                        <Form layout="vertical">
                                            <Row gutter={8} align="" className="mb-4">
                                                <Col md={2}>
                                                    <div className="filter-group">
                                                        <Select
                                                            placeholder="Select an ad network"
                                                            options={[
                                                                { value: " FB ads (FT Global - Inv1)", label: " FB ads (FT Global - Inv1)" },
                                                                { value: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)", label: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)" },
                                                            ]}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={2} >
                                                    <div className="filter-group">
                                                        <Select
                                                            placeholder="Select campaign"
                                                            options={[
                                                                { value: " FB ads (FT Global - Inv1)", label: " FB ads (FT Global - Inv1)" },
                                                                { value: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)", label: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)" },
                                                            ]}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={2} >
                                                    <div className="filter-group">
                                                        <Select
                                                            placeholder="Select country"
                                                            options={[
                                                                { value: " FB ads (FT Global - Inv1)", label: " FB ads (FT Global - Inv1)" },
                                                                { value: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)", label: " FB ads (FTGlobal - Account01 - Puzzle - Invoice SG)" },
                                                            ]}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={2} >
                                                    <div className="filter-group">
                                                        <RangePicker
                                                            ranges={{
                                                                'This Week': [moment().startOf('week'), moment().endOf('week')],
                                                                'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                                                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                                                                'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                                                                'Last 10 Days': [moment().subtract(10, 'days'), moment()],
                                                                'Last 30 Days': [moment().subtract(30, 'days'), moment()],
                                                            }}
                                                            style={{ width: '100%' }}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col md={2} >
                                                    <div className="filter-group" style={{ display: "flex", alignItems: "center", gap: 8, flexDirection: "unset" }}>
                                                        <div>Predict LTV</div>
                                                        <InputNumber
                                                            style={{ width: 100 }}
                                                            formatter={(value) => `D ${value || ''}`}
                                                            parser={(value) => value.replace(/^D\s?/, '')}
                                                            placeholder="Nhập số"
                                                        />
                                                    </div>
                                                </Col>

                                                <Col md={2} >
                                                    <div className="filter-group" style={{ display: "flex", alignItems: "center", gap: 8, flexDirection: "unset" }}>
                                                        <div>View by:</div>
                                                        <Radio.Group value="Country">
                                                            <Radio.Button value="Country">Country</Radio.Button>
                                                            <Radio.Button value="Campaign">Campaign</Radio.Button>
                                                        </Radio.Group>
                                                    </div>
                                                </Col>

                                                <Col md={2} >
                                                    <AntButton
                                                        type="primary"
                                                        onClick={() => setHasRunReportMetrics(true)}
                                                        className="run-report-btn"
                                                    >
                                                        Run
                                                    </AntButton>
                                                </Col>
                                            </Row>
                                        </Form>

                                        <Row className="mb-4">
                                            <Col md={12}>
                                                <div className="flex items-start justify-between w-full">
                                                    <div className="ml-4 text-right font-semibold">
                                                        <div>
                                                            Future ARPDAU:
                                                            <Radio.Group value="Use_latest_ARPDAU">
                                                                <Radio.Button value="Use_latest_ARPDAU">Use latest ARPDAU</Radio.Button>
                                                                <Radio.Button value="Use_average_ARPDAU">Use average ARPDAU</Radio.Button>
                                                            </Radio.Group>
                                                        </div>
                                                    </div>

                                                </div>
                                            </Col>
                                        </Row>

                                        {(hasRunReportTop || hasRunReportMetrics) && (
                                            <div className="table_overview_content pd-20">
                                                <TableContainer
                                                    fields={fields}
                                                    getVisibleColumns={getVisibleColumns}
                                                    sortConfig={sortConfig}
                                                    toggleSort={toggleSort}
                                                    getFieldLabel={getFieldLabel}
                                                    hasActiveFilter={hasActiveFilter}
                                                    handleColumnFilterClick={handleColumnFilterClick}
                                                    sortedData={sortedData}
                                                    renderGroup={renderGroup}
                                                    dataTotal={dataTotal}
                                                    formatNumber={formatNumber}
                                                    METRIC_FORMATS={METRIC_FORMATS}
                                                    columnFilterPopup={columnFilterPopup}
                                                    columnPopupRef={columnPopupRef}
                                                    ColumnFilterPopupContent={() => null}
                                                    filters={filters}
                                                    updateCondition={updateCondition}
                                                    onCloseColumnFilterPopup={() => setColumnFilterPopup({ activeColumn: null, position: { top: 0, left: 0 } })}
                                                    showPopup={showPopup}
                                                    togglePopup={() => setShowPopup((v) => !v)}
                                                    fieldsPanel={{}}
                                                    showFilterPanel={showFilterPanel}
                                                    setShowFilterPanel={setShowFilterPanel}
                                                    columnsPanel={{ searchTerm, setSearchTerm, columnOrder, setAllColumnsVisible, ColumnField: null }}
                                                    headerDrag={{ moveColumn }}
                                                    setFilters={setFilters}
                                                    filterableColumns={filterableColumns}
                                                    toggleFieldExpand={toggleFieldExpand}
                                                    renderFilterFieldControls={renderFilterFieldControls}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </section>
            </div>
        </>
    );
}

export default AppPrediction;